if(document.querySelector('.c-accordions')) {
    const accordions = document.querySelectorAll('.c-accordions__item');

    accordions.forEach(accordion => {
        accordion.addEventListener('click', ()=> {
            accordion.classList.toggle('open');
            
            const accordionContent = accordion.querySelector('.c-accordions__item-content');
            
            if(!accordion.classList.contains('open')) {
                accordionContent.style.setProperty('--text-height', '0px');
            } else {
                accordionContent.style.setProperty('--text-height', accordionContent.scrollHeight + 'px');
            }
        })
    });
}